import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AuthenticationApplicationsKerberosX509Module = () => (
  <QPhototModuleSubtopic
    title="Authentication Applications: Kerberos, X.509 Authentication Service"
    videos={[
      "https://www.youtube.com/embed/df6UMCcxN6Y",
      "https://www.youtube.com/embed/3u1YSCx5q-w"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "Describe how Kerberos-V4 provides authentication service in an open distributed environment where users work in different workstations and access services from the servers distributed throughout the network."
      },
      {
        text:
          "Using Kerberos-V4, explain how the authentication service and the ticket-granting service are provided."
      },
      {
        text:
          "Identify three security threats concerning node authentication in a networked environment and, for each threat you have identified, explain the countermeasure used in the Kerberos-V4 protocol."
      },
      {
        text:
          "Describe how Kerberos-V4 provides authentication service in an open distributed environment where users work in different workstations and access services from the servers distributed throughout the network."
      }
    ]}
    exampleVideos={[]}
  />
);

export default AuthenticationApplicationsKerberosX509Module;
